import React from 'react';
import {withStore} from "../hocs";
import {observer} from "mobx-react";
import {RedirectUrl} from "../components/RedirectUrl";
import {Link} from "react-router-dom";


// @ts-ignore
@withStore
@observer
export default class LoyaltyPage extends React.Component {

    componentDidMount() {
        // @ts-ignore
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <>
                <RedirectUrl/>
                <div className="container">

                    <div className="breadcrumbs">
                        <div className="breadcrumbs-wrapper">
                            <ul className="breadcrumbs__list">
                                <li className="breadcrumbs__item" >
                                    <Link  to="/" >
                                        <span className= "breadcrumbs__item-text">Главная - </span>
                                    </Link>

                                    <span className= "breadcrumbs__item-text-active">ПРАВИЛА БОНУСНОЙ ПРОГРАММЫ</span>

                                </li>
                            </ul>
                        </div>
                    </div>


                    <div className="catalog-title">
                        <h1 className="catalog-title__text">ПРАВИЛА БОНУСНОЙ ПРОГРАММЫ</h1>
                    </div>
                    <br/>
                    <div >

                       <h2>
                           1. Общая информация
                       </h2>
                        <p>
                            1.1. Бонусная программа (далее – Программа) – Программа поощрения потребителей – юридических
                            лиц, совершающих покупки на интернет-портале ООО «Сэльвин». Программа действует на территории
                            Республики Беларусь.
                       </p>
                        <p>
                            1.2. Организатор Программы (далее – Организатор) – общество с ограниченной ответственностью «Сэльвин».
                       </p>
                        <p>
                            1.3. Сайт Организатора (далее – Сайт) – b2b.sellwin.by.
                       </p>
                        <p>
                            1.4. Участник Программы (далее – Участник) – юридическое лицо, зарегистрированное на Сайте,
                            которое выполняет все требования участия в Программе и подтверждает свое участие в
                            Программе в порядке, предусмотренном настоящими правилами.
                       </p>
                        <p>
                            1.5. Личный кабинет – персонализированный раздел Участника на Сайте, предназначенный для
                            подключения (регистрации), участия в Программе и ведения Бонусного счета.
                       </p>
                        <p>
                            1.6. Бонусный счет – счет Участника, по которому учитывается информация по всем действиям,
                            совершаемым Участником на сайте. Бонусный счет ведется в Бонусах. Бонусы начисляются на
                            Бонусный счет и списываются с Бонусного счета при приобретении у Организатора товаров в соответствии с правилами.
                       </p>
                        <p>
                            1.7. Сумма покупок (накоплений) – это сумма, фактически оплаченная безналичными денежными средствами.
                            Если при совершении покупки были использованы Бонусы, то в сумме покупок учитывается только та часть,
                            которая была непосредственно оплачена безналичными денежными средствами.
                        </p>
                        <p>
                            1.8. Бонусный балл (далее – Бонус) – единица учета скидки, представляющая из себя числовое
                            значение (сумму), которая рассчитывается на условиях настоящей Программы и начисляется на
                            Бонусный счет Участника, впоследствии дает право Участнику на получение скидки на Сайте.
                        </p>
                        <p>
                            1.9. Программа является бессрочной, однако Организатор сохраняет за собой право изменить или
                            отменить ее условия, включая структуру накоплений, схему начисления Бонусов, других условий
                            и/или прекратить, приостановить действие Программы в целом в любое время. Организатор также
                            оставляет за собой право закрыть Программу, уведомив ее Участников за один месяц до предстоящего
                            закрытия и разместив информацию на Сайте.
                        </p>
                        <p>
                            1.10. Информация о Программе, о внесении изменений либо прекращении действия Программы
                            размещается на Сайте. Изменения в Программе становятся действительными с момента публикации
                            на Сайте. Незнание положений Программы не является основанием для предъявления каких-либо
                            претензий со стороны Участников к Организатору.
                        </p>
                        <p>
                            1.11. Участие в Программе является добровольным. К участию в Программе не допускаются физические лица.
                        </p>
                        <p>
                            1.12. Программа вводится в действие с 01 февраля 2024 года.
                        </p>
                        <h2>
                            2. Участие в Программе
                        </h2>
                        <p>
                            2.1. Для участия в Программе необходимо зарегистрироваться на Сайте, после чего у Участника
                            Программы появится Личный кабинет;
                        </p>
                        <p>
                            2.2. Бонусный счет ведется в Личном кабинете.
                        </p>
                        <h2>
                            3. Типы Бонусов, условия их начисления и использования
                        </h2>
                        <p>
                            3.1. В рамках действия Программы на Бонусный счет Участника начисляются Бонусы, которые могут
                            быть использованы при последующих покупках в интернет-магазине Организатора:
                        </p>
                        <p>
                            3.1.1. Бонусы начисляются на весь товар, продаваемый на сайте (в т.ч. акционный и распродажа);
                        </p>
                        <p>
                            3.2.2. Виды бонусов и их размер.
                        </p>
                        <p>
                            Размер бонусов и их градация устанавливаются Организатором <a href="../img/LoyaltyProgramSellwin.pdf" style={{color: "blue", cursor: "pointer", textDecoration: "underline"}} download>отдельным документом</a> к настоящей Бонусной программе
                        </p>
                        <p>
                            3.2. Бонусы начисляются за покупки в интернет-магазине Организатора в момент оформления заказа
                            и служат информацией для Участника о количестве начисленных баллов.
                        </p>
                        <p>
                            Бонусы рассчитываются в зависимости от суммы заказанных товаров на Сайте.
                        </p>
                        <p>
                            3.3. Фактическое зачисление бонусов в Личном кабинете Участника происходит в течение 5-ти
                            календарных дней с даты отгрузки товара Участнику.
                        </p>
                        <p>
                            3.4. Организатор по своему усмотрению может вводить ограничения в список товаров и услуг,
                            при оплате которых Бонусы не начисляются.
                        </p>
                        <p>
                            3.5. В случае возврата товара Участнику предварительно начисленные Бонусы не зачисляются на
                            счет Участника. Начисленные за покупку Бонусы аннулируются.
                        </p>
                        <p>
                            3.6. Бонусы не подлежат обмену на денежные средства.
                        </p>
                        <p>
                            3.7. Бонусы применяются и списываются только на определенный перечень товаров.
                        </p>
                        <p>
                            Товар, к которому не применяется списание бонусов, определен Организатором и наделен
                            отдельным признаком и вынесен в отдельный раздел общего каталога.
                        </p>
                        <p>
                            3.8. Бонусы могут быть списаны по инициативе Организатора без предварительного уведомления
                            Участника в случае, если они были начислены на Бонусный счет Участника ошибочно,
                            в результате действий Участника или иного лица, содержащих элементы недобросовестности,
                            или по иным основаниям, определенным по решению Организатора.
                        </p>
                        <p>
                            3.9. Списание бонусов возможно при следующем заказе после фактически реализованного заказа,
                            на который были начислены бонусы, и после их зачисления в Личном кабинете Участника Программы.
                        </p>
                        <p>
                            3.10. Бонусами можно списать стоимость следующего заказа не более, чем 25% от стоимости
                            бонусных товаров в ценах Прейскуранта. Списание бонусов может происходить только на
                            определенный ассортимент, указанный Организатором.
                        </p>
                        <p>
                            3.11. В момент списания Бонусов при заказе, на этот заказ происходит зачисление Бонусов согласно п. 3.1.1.
                        </p>
                        <p>
                            3.12. Бонусы накапливаются в рамках юридического лица – Участника Программы.
                        </p>
                        <p>
                            3.13. Организатор вправе прекратить участие в Программе любого Участника и заблокировать/аннулировать
                            Бонусный счет без уведомления в случаях, если Участник:
                        </p>
                        <p>
                            3.13.1. не соблюдает правила Программы;
                        </p>
                        <p>
                            3.13.2. совершил или намеревается совершить действия, имеющие явные признаки мошенничества,
                            обман или прочие манипуляции, которые повлекли или могут повлечь за собой материальный ущерб,
                            моральные и прочие негативные последствия;
                        </p>
                        <p>
                            3.13.3. злоупотребляет какими-либо правами, предоставляемыми Участнику в рамках Программы;
                        </p>
                        <p>
                            3.13.4. предоставляет информацию (сведения), вводящую в заблуждение, либо не соответствующую действительности;
                        </p>
                        <p>
                            3.13.5. в соответствии с требованиями действующего законодательства;
                        </p>
                        <h2>
                            4. Информирование участников Программы
                        </h2>
                        <p>
                            4.1. Участники Программы при регистрации на Сайте Организатора подтверждают свое согласие на:
                        </p>
                        <p>
                            4.1.1. обработку своих персональных данных посредством сбора, записи, систематизации, накопления,
                            хранения, уточнения, извлечения, использования, осуществляемую с использованием средств автоматизации,
                            в том числе в информационно-телекоммуникационных сетях, в том числе на передачу организациям,
                            осуществляющим запись, систематизацию, накопление, уточнение, хранение, извлечение, непосредственно
                            осуществляющим направление специальных предложений, сервисной информации и информаций о новых товарах
                            и рекламных акциях, а так же осуществляющих уничтожение персональных данных;
                        </p>
                        <p>
                            4.1.2. получение ими сервисных уведомлений и специальных предложений, информации о начислении, сумме и сроках действия Бонусов;
                        </p>
                        <p>
                            4.1.3. получение ими информации о новых товарах и рекламных акциях, иной рекламной информации;
                        </p>
                        <p>
                            4.1.4. соблюдение и согласие со всеми правилами Программы, в частности, порядком начисления,
                            списания и действия Бонусов, хранением и обработкой персональных данных.
                        </p>
                        <p>
                            4.2. Участники Программы, подтвердившие согласие на получение информации от Организатора, получают рассылку в Личном кабинете.
                        </p>
                        <p>
                            Периодичность направления сервисной и рекламной информации определяется Организатором.
                        </p>

                    </div>
                </div>
            </>
        )
    }
}